// Frans (fr-FR), design: zelfde vorm als design.nl.ts. Pictogramnamen kort (tegels), in de
// woorden van een kind. Zoekwoorden: Franse woorden plus de gangbare woorden uit andere talen
// (namaz, salat, abdest); een woordgroep met liggend streepje telt als geheel.
export const designFr = {
    picto: {
        'brush-teeth': 'Se brosser les dents',
        'get-dressed': 'S’habiller',
        shoes: 'Chaussures',
        coat: 'Manteau',
        'wash-hands': 'Se laver les mains',
        toilet: 'Toilettes',
        shower: 'Douche',
        bath: 'Bain',
        sleep: 'Dormir',
        alarm: 'Réveil',
        prayer: 'Prier',
        wudu: 'Ablutions',
        'make-bed': 'Lit',
        'tidy-up': 'Ranger',
        'set-table': 'Mettre la table',
        'clear-table': 'Débarrasser la table',
        dishes: 'Vaisselle',
        dishwasher: 'Vider le lave-vaisselle',
        vacuum: 'Aspirateur',
        sweep: 'Balayer',
        cleaning: 'Nettoyer',
        windows: 'Laver les vitres',
        laundry: 'Lessive',
        'fold-laundry': 'Plier le linge',
        trash: 'Poubelles',
        recycling: 'Trier les déchets',
        'water-plants': 'Arroser les plantes',
        garden: 'Jardin',
        'walk-dog': 'Promener le chien',
        'feed-cat': 'Nourrir le chat',
        'feed-fish': 'Nourrir les poissons',
        'feed-rabbit': 'Nourrir le lapin',
        mail: 'Courrier',
        school: 'École',
        backpack: 'Cartable',
        homework: 'Devoirs',
        reading: 'Lire',
        library: 'Bibliothèque',
        lecture: 'Conférence',
        mosque: 'Mosquée',
        quran: 'Coran',
        computer: 'Ordinateur',
        work: 'Travail',
        'phone-call': 'Appeler',
        calendar: 'Rendez-vous',
        soccer: 'Football',
        hockey: 'Hockey',
        swimming: 'Piscine',
        gymnastics: 'Gym',
        dance: 'Danse',
        ballet: 'Ballet',
        tennis: 'Tennis',
        basketball: 'Basket',
        judo: 'Judo',
        'horse-riding': 'Équitation',
        skating: 'Patin',
        running: 'Course à pied',
        cycling: 'Vélo',
        playground: 'Aire de jeux',
        'music-lesson': 'Cours de musique',
        piano: 'Piano',
        guitar: 'Guitare',
        violin: 'Violon',
        drums: 'Batterie',
        singing: 'Chant',
        theater: 'Théâtre',
        drawing: 'Dessin',
        painting: 'Peinture',
        crafts: 'Bricolage',
        puzzle: 'Puzzle',
        play: 'Jouer',
        gaming: 'Jeux vidéo',
        tv: 'Télé',
        'screen-time': 'Temps d’écran',
        dentist: 'Dentiste',
        doctor: 'Médecin',
        hospital: 'Hôpital',
        medicine: 'Médicaments',
        sick: 'Malade',
        haircut: 'Coiffeur',
        birthday: 'Anniversaire',
        party: 'Fête',
        gift: 'Cadeau',
        wish: 'Souhait',
        chat: 'Messages',
        sohbet: 'Sohbet',
        grandma: 'Mamie',
        grandpa: 'Papi',
        family: 'Famille',
        babysitter: 'Baby-sitter',
        playdate: 'Jouer avec un copain',
        sleepover: 'Soirée pyjama',
        home: 'Maison',
        holiday: 'Vacances',
        travel: 'Voyage',
        camping: 'Camping',
        zoo: 'Zoo',
        museum: 'Musée',
        cinema: 'Cinéma',
        car: 'Voiture',
        bus: 'Bus',
        train: 'Train',
        walk: 'Promenade',
        church: 'Église',
        shabbat: 'Chabbat',
        synagogue: 'Synagogue',
        mandir: 'Mandir',
        moon: 'Lune',
        breakfast: 'Petit-déjeuner',
        lunch: 'Déjeuner',
        dinner: 'Dîner',
        fruit: 'Fruit',
        drink: 'Boire',
        cooking: 'Cuisiner',
        baking: 'Pâtisserie',
        groceries: 'Courses',
        'ice-cream': 'Glace',
        popcorn: 'Soirée film',
        pizza: 'Pizza',
        pancakes: 'Crêpes',
        soup: 'Soupe',
        'oven-dish': 'Gratin',
        stamppot: 'Stamppot',
        lasagne: 'Lasagnes',
        curry: 'Curry',
        noodles: 'Nouilles',
        taco: 'Tacos',
        wrap: 'Wrap',
        salad: 'Salade',
        hamburger: 'Hamburger',
        fries: 'Frites',
        dumplings: 'Raviolis',
        waffle: 'Gaufre',
        pie: 'Tarte',
        cake: 'Gâteau',
        pudding: 'Dessert',
        banana: 'Banane',
        pear: 'Poire',
        orange: 'Orange',
        lemon: 'Citron',
        strawberry: 'Fraises',
        grapes: 'Raisin',
        tomato: 'Tomate',
        cucumber: 'Concombre',
        carrot: 'Carotte',
        broccoli: 'Brocoli',
        lettuce: 'Salade verte',
        'bell-pepper': 'Poivron',
        onion: 'Oignon',
        garlic: 'Ail',
        potato: 'Pommes de terre',
        mushroom: 'Champignons',
        corn: 'Maïs',
        avocado: 'Avocat',
        cheese: 'Fromage',
        butter: 'Beurre',
        egg: 'Œufs',
        yoghurt: 'Yaourt',
        croissant: 'Croissant',
        honey: 'Miel',
        meat: 'Viande',
        chicken: 'Poulet',
        bacon: 'Lardons',
        fish: 'Poisson',
        shrimp: 'Crevettes',
        sausage: 'Saucisse',
        rice: 'Riz',
        salt: 'Sel',
        'canned-food': 'Conserve',
        peanuts: 'Cacahuètes',
        chocolate: 'Chocolat',
        cookie: 'Biscuits',
        jar: 'Bocal',
        coffee: 'Café',
        tea: 'Thé',
        juice: 'Jus',
        water: 'Eau',
        'toilet-paper': 'Papier toilette',
        soap: 'Savon',
        sponge: 'Éponge',
        basket: 'Panier',
        'baby-bottle': 'Lait bébé',
        receipt: 'Ticket de caisse',
        store: 'Magasin',
        star: 'Étoile',
        trophy: 'Coupe',
        medal: 'Médaille',
        savings: 'Économiser',
        fox: 'Renard',
        cat: 'Chat',
        rabbit: 'Lapin',
        bear: 'Ours',
        panda: 'Panda',
        koala: 'Koala',
        owl: 'Hibou',
        lion: 'Lion',
        tiger: 'Tigre',
        monkey: 'Singe',
        unicorn: 'Licorne',
        dino: 'Dino',
        turtle: 'Tortue',
        frog: 'Grenouille',
        hedgehog: 'Hérisson',
        penguin: 'Pingouin',
        dolphin: 'Dauphin',
        butterfly: 'Papillon',
        rocket: 'Fusée',
        sunflower: 'Tournesol',
        rainbow: 'Arc-en-ciel',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'Arche',
        'shape-wave': 'Vagues',
        'shape-leaf': 'Feuille',
        'shape-hills': 'Collines',
        'shape-ring': 'Anneau',
        'shape-spark': 'Étincelle',
        towel: 'Serviette',
        underwear: 'Culotte ou slip',
        socks: 'Chaussettes',
        'swim-trunks': 'Maillot de bain',
        swimsuit: 'Maillot une pièce',
        shampoo: 'Shampooing',
        slippers: 'Tongs',
        'football-boots': 'Chaussures de foot',
        'shin-guards': 'Protège-tibias',
        'water-bottle': 'Gourde',
        headscarf: 'Foulard',
        'prayer-cap': 'Calotte de prière',
    },
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'conference conferences expose lecture lezing ders vortrag seminaire',
        sohbet: 'sohbet sohbeti muhabbet',
        mosque: 'mosquée cours_mosquée cours_à_la_mosquée masjid islam coran cours_coran arabe cours_arabe camii cami_ders kuran hafizlik',
        prayer: 'prier prière prières namaz salah salat tarawih teravih douaa dua',
        wudu: 'wudu woudou ablutions faire_ses_ablutions abdest abdest_almak',
        quran: 'coran cours_coran kuran quran hafiz hifz tajwid',
        church: 'église messe culte chrétien chapelle',
        shabbat: 'chabbat shabbat sabbat juif',
        synagogue: 'synagogue juif',
        mandir: 'mandir temple hindou hindouisme puja',
        moon: 'lune croissant_lune demi_lune ramadan',
        towel: 'serviette serviette_bain',
        underwear: 'culotte slip sous_vêtements caleçon',
        socks: 'chaussettes chaussette',
        'swim-trunks': 'maillot maillot_bain',
        swimsuit: 'maillot_une_pièce bikini',
        shampoo: 'shampooing shampoing gel_douche savon',
        slippers: 'tongs claquettes sandales',
        'football-boots': 'chaussures_foot crampons',
        'shin-guards': 'protège_tibias protège_tibia',
        'water-bottle': 'gourde bouteille_eau',
        headscarf: 'foulard hijab',
        'prayer-cap': 'calotte_prière calotte kufi takke',
    },
    pictoCategory: {
        routine: 'Rythme de la journée',
        chores: 'Petites tâches',
        school: 'École et travail',
        sport: 'Sport',
        hobby: 'Musique et loisirs',
        care: 'Santé',
        family: 'Famille et sorties',
        food: 'Repas',
        groceries: 'Courses',
        reward: 'Récompense',
        avatar: 'Animaux et personnages',
        packing: 'Dans le sac',
    },
    color: {
        orange: 'Orange',
        skyblue: 'Bleu clair',
        bluishgreen: 'Vert',
        yellow: 'Jaune',
        blue: 'Bleu',
        vermillion: 'Rouge',
        reddishpurple: 'Rose',
        black: 'Gris',
    },
    eventCard: {
        allDay: 'Toute la journée',
        cancelled: 'Annulé',
        everyone: 'Tout le monde',
        whoDrives: 'Qui conduit ?',
        drives: '{name} conduit',
        splitDrives: '{dropoff} dépose · {pickup} récupère',
        repeat: 'Se répète',
        moved: 'Déplacé',
        changed: 'Modifié',
    },
    check: {
        label: '{task} : fini ?',
        confirm: 'Fini !',
        undo: 'Oups',
    },
    points: {
        earned: { one: '{count} point', other: '{count} points' },
        reserved: '{count} en réserve',
    },
    progress: '{done} sur {total} finies',
    celebrate: {
        task: 'Bravo, {name} !',
        allDone: 'Tout est fini !',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'Terminé',
            task: 'Fait par {name}',
            allDone: 'Tout est fait pour aujourd’hui',
        },
    },
    colorPicker: {
        label: 'Couleur',
        takenBy: 'Déjà choisie par {name}',
        takenOne: '{color} est déjà à {name}',
    },
    iconPicker: {
        label: 'Pictogramme',
        search: 'Chercher un pictogramme',
        none: 'Pas de pictogramme',
        noResults: 'Rien trouvé pour « {query} »',
        all: 'Tout',
        more: '+{count} de plus',
    },
    toast: {
        undo: 'Annuler',
        dismiss: 'Fermer le message',
    },
    dialog: {
        close: 'Fermer',
        fullScreen: 'Plein écran',
        smallScreen: 'Réduire',
    },
    calendar: {
        weekShort: 'sem.',
        more: '+{count} de plus',
        moreShort: '+{count}',
        now: 'Maintenant',
    },
    editor: {
        title: 'Titre',
        titleHint: 'Court et clair, par exemple Piscine',
        repeat: 'Répéter',
        repeatNone: 'Jamais',
        repeatDaily: 'Chaque jour',
        repeatWeekly: 'Chaque semaine le {weekday}',
        repeatMonthly: 'Chaque mois',
        duplicate: 'Dupliquer',
        approvalRequired: 'Validation nécessaire',
        approvalHint: 'Papa ou maman valide la tâche avant que les points comptent.',
        deleteQuestion: 'Supprimer {title} ?',
        repeatsWeekly: 'Cet événement se répète chaque semaine.',
    },
    scope: {
        editTitle: 'Que veux-tu modifier ?',
        deleteTitle: 'Que veux-tu supprimer ?',
        this: 'Seulement cette fois',
        following: 'Celle-ci et les suivantes',
        all: 'Toute la série',
        times: { one: '{count} fois', other: '{count} fois' },
        from: 'à partir du {date}',
    },
    view: {
        label: 'Affichage',
        day: 'Jour',
        week: 'Semaine',
        month: 'Mois',
    },
    inbox: {
        label: 'À valider',
        open: 'À traiter',
        done: 'Traité',
    },
    empty: {
        welcomeTitle: 'Bienvenue à la maison',
        welcomeBody: 'Voir la semaine ensemble, sans prise de tête. On commence par ta famille.',
        emptyDayTitle: 'Rien de prévu aujourd’hui',
        emptyDayBody: 'Une journée calme. Envie de faire un truc sympa ?',
        noTasksTitle: 'Pas de tâches aujourd’hui',
        noTasksBody: 'Journée libre !',
        allDoneTitle: 'Tout est fait',
        allDoneBody: 'Il ne reste plus rien à faire.',
        offlineTitle: 'Pas de connexion',
        offlineBody: 'Tu vois la dernière mise à jour. Tout va revenir tout seul.',
        nightTitle: 'Bonne nuit',
        nightBody: 'Demain à {time} : {title}',
        rewardsTitle: 'Pas encore de récompenses',
        rewardsBody: 'Trouve avec ta famille un objectif à atteindre.',
        inviteTitle: 'Invite ton ou ta partenaire',
        inviteBody: 'À deux, c’est plus simple de s’organiser. Envoie une invitation par e-mail.',
        oopsTitle: 'Oups, ça n’a pas marché',
        oopsBody: 'Réessaie. Ça ne marche toujours pas ? Recharge la page.',
        pairTitle: 'Associe la tablette',
        pairBody: 'Ouvre le tableau familial sur la tablette et saisis le code ici.',
    },
    credits: 'Pictogrammes, icônes et illustrations : AMUMIN',
    gallery: {
        title: 'Galerie de design',
        intro: 'Tous les éléments du tableau familial au même endroit : tokens, composants, pictogrammes et illustrations. Visible uniquement en développement.',
        theme: 'Thème',
        themeLight: 'Jour',
        themeDark: 'Soir',
        themeNight: 'Nuit',
        colors: 'Couleurs',
        memberColors: 'Couleurs des membres',
        neutrals: 'Neutres',
        semantic: 'Signification',
        typography: 'Typographie',
        spacing: 'Espaces et formes',
        kiosk: 'Éléments du kiosque',
        web: 'Éléments de l’appli web',
        icons: 'Icônes',
        pictograms: 'Pictogrammes',
        illustrations: 'Illustrations',
        sample: 'Exemple',
    },
};
//# sourceMappingURL=design.fr.js.map